export default "__VITE_ASSET__BPxjrGjI__"